import { Asterisk } from "lucide-react";

const ITEMS = ["Pisos y casas", "Alquiler y venta", "Toda España", "Mejores precios", "Trato directo", "Todo en persona"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <span key={`${item}-${hidden}`} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-serif text-2xl italic text-white sm:px-10 sm:text-3xl">
          {item}
        </span>
        <Asterisk className="h-5 w-5 shrink-0 text-[#f59e0b]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="overflow-hidden bg-[#0f766e] py-6" data-testid="tags-marquee" aria-label="Pisos y casas, alquiler y venta, toda España, mejores precios, trato directo, todo en persona">
      <div className="marquee-track flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
